import Drawer from "components/shared/Drawer/Drawer";
import { PaymentDetailsContent } from "./PaymentDetails";
import { TransactionDetailContent } from "./TransactionDetailSheet";
import { DrawerScreen } from "./styles.payoutDesktop";

export default function PayoutDetailDrawer({ referenceNumber, transaction, onClose }) {
  if (!referenceNumber && !transaction) return null;

  return (
    <Drawer
      title={referenceNumber ? "Payment details" : "Transaction detail"}
      onClose={onClose}
    >
      <DrawerScreen>
        {referenceNumber ? (
          <PaymentDetailsContent referenceNumber={referenceNumber} />
        ) : (
          <TransactionDetailContent item={transaction} />
        )}
      </DrawerScreen>
    </Drawer>
  );
}
